import { render } from "./course-detail.vue?vue&type=template&id=4c170db5"
import script from "./course-detail.vue?vue&type=script&lang=js"
export * from "./course-detail.vue?vue&type=script&lang=js"

import "./course-detail.vue?vue&type=style&index=0&id=4c170db5&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__